/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Hausa2Inputs */

const en__field__enum_nativelanguage_hausa2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Hausa2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hausa`)
};

const de__field__enum_nativelanguage_hausa2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Hausa2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hausa`)
};

/**
* | output |
* | --- |
* | "Hausa" |
*
* @param {_Field__Enum_Nativelanguage_Hausa2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_hausa2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Hausa2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Hausa2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_hausa2(inputs)
	return de__field__enum_nativelanguage_hausa2(inputs)
});
export { _field__enum_nativelanguage_hausa2 as "_field__enum_nativeLanguage_Hausa" }